import { __assign, __read, __spread } from "tslib";
import { applySchemaTransforms } from '@graphql-tools/utils';
import { FIELD_SUBSCHEMA_MAP_SYMBOL, OBJECT_SUBSCHEMA_SYMBOL } from './symbols';
export function getSubschema(result, responseKey) {
    var subschema = result[FIELD_SUBSCHEMA_MAP_SYMBOL] && result[FIELD_SUBSCHEMA_MAP_SYMBOL][responseKey];
    return subschema || result[OBJECT_SUBSCHEMA_SYMBOL];
}
export function setObjectSubschema(result, subschema) {
    result[OBJECT_SUBSCHEMA_SYMBOL] = subschema;
}
export function isSubschemaConfig(value) {
    return Boolean(value.schema && value.permutations === undefined);
}
export function cloneSubschemaConfig(subschemaConfig) {
    var newSubschemaConfig = __assign(__assign({}, subschemaConfig), { transforms: subschemaConfig.transforms != null ? __spread(subschemaConfig.transforms) : undefined });
    if (newSubschemaConfig.merge != null) {
        newSubschemaConfig.merge = __assign({}, subschemaConfig.merge);
        Object.keys(newSubschemaConfig.merge).forEach(function (typeName) {
            newSubschemaConfig.merge[typeName] = __assign({}, subschemaConfig.merge[typeName]);
            var fields = newSubschemaConfig.merge[typeName].fields;
            if (fields != null) {
                Object.keys(fields).forEach(function (fieldName) {
                    fields[fieldName] = __assign({}, fields[fieldName]);
                });
            }
            var computedFields = newSubschemaConfig.merge[typeName].computedFields;
            if (computedFields != null) {
                Object.keys(computedFields).forEach(function (fieldName) {
                    computedFields[fieldName] = __assign({}, computedFields[fieldName]);
                });
            }
        });
    }
    return newSubschemaConfig;
}
export function isSubschema(value) {
    return Boolean(value.transformedSchema);
}
var Subschema = /** @class */ (function () {
    function Subschema(config) {
        var _a;
        this.schema = config.schema;
        this.rootValue = config.rootValue;
        this.executor = config.executor;
        this.subscriber = config.subscriber;
        this.batch = config.batch;
        this.batchingOptions = config.batchingOptions;
        this.endpoint = config.endpoint;
        this.createProxyingResolver = config.createProxyingResolver;
        this.transforms = (_a = config.transforms) !== null && _a !== void 0 ? _a : [];
        this.transformedSchema = applySchemaTransforms(this.schema, this.transforms);
        this.merge = config.merge;
    }
    return Subschema;
}());
export { Subschema };
//# sourceMappingURL=Subschema.js.map